import React, { useEffect, useMemo, useState } from "react";
import { MENU_ITEMS } from "constants";
import MenuItem from "./MenuItem";
import { MenuList } from "./styles";
import useUser from "hooks/useUser";
import http from "services/httpService";

function Menu() {
  const { getRole } = useUser();
  const [featureDetails, setFeatureDetails] = useState();

  const permissions = useMemo(() => {
    if(!featureDetails) return null;
    return {
      claims: featureDetails?.show_claim_summary,
      collection_history: featureDetails?.collection_allowed
    }
  }, [featureDetails])

  useEffect(() => {
    getFeatureList();
  }, [])

  const getFeatureList = async () => {
    const { data } = await http.get("/business/get_company_product_details/");
    setFeatureDetails(data);
  }

  const permittedRoutes = useMemo(() => {
    return MENU_ITEMS.filter((item) => {
      const role = getRole();
      switch(item.path) {
        case "/v1/data-collection-history":
          return permissions?.collection_history || false;
        case "/v1/data-collection-history/collect":
          return permissions?.collection_history || false;
        case "/v1/claims":
          return permissions?.claims || false;
      }
      if (item.role) {
        return item.role == role;
      }
      return true;
    });
  }, [featureDetails]);

  const excludedLinks = ["Wellness"];

  return (
    <MenuList>
      {permittedRoutes
        .filter((item) => !excludedLinks.includes(item.name))
        .map(({ name, path, subPaths }) => (
          <MenuItem key={name} path={path} subPaths={subPaths}>
            {name}
          </MenuItem>
        ))}
    </MenuList>
  );
}

export default Menu;
